<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/purchase/requisition' }">采购申请</el-breadcrumb-item>
                <el-breadcrumb-item>{{ isEdit ? '编辑申请单' : isView ? '查看申请单' : '新增申请单' }}</el-breadcrumb-item>
            </el-breadcrumb>
        </template>

        <el-tabs v-model="activeTab" type="border-card">
            <!-- 基本信息 Tab -->
            <el-tab-pane label="基本信息" name="basic">
                <el-form :model="forms" :rules="rules" ref="forms" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请单号" prop="billCode">
                                <el-input v-model="forms.billCode" :disabled="true || isEdit || isView"
                                    style="max-width: 220px;"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="单据类型" prop="billType" style="width:350px">
                                <el-select v-model="forms.billType" placeholder="请选择" :disabled="isView">
                                    <el-option label="常规采购" value="常规采购"></el-option>
                                    <el-option label="紧急采购" value="紧急采购"></el-option>
                                    <el-option label="计划采购" value="计划采购"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="制单日期" prop="billDate">
                                <el-date-picker v-model="forms.billDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="所属公司" prop="companyID">
                                <el-tree-select ref="companys" v-model="forms.companyID" :data="companys"
                                    @change="companyChange();" check-strictly
                                    :render-after-expand="false" style="width: 280px;" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请部门" prop="departmentID">
                                <el-tree-select ref="departments" v-model="forms.departmentID" :data="departments"
                                    clearable check-strictly :render-after-expand="false" style="width:220px"
                                    @change="onDepartmentChange" />
                            </el-form-item>
                        </el-col>

                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请人" prop="applicantName">
                                <el-input v-model="forms.applicantName" :disabled="isView"
                                    style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="申请日期" prop="applicantDate">
                                <el-date-picker v-model="forms.applicantDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="需求日期" prop="requirementDate">
                                <el-date-picker v-model="forms.requirementDate" type="date" :disabled="isView"
                                    style="width:220px"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="外部编号" prop="externalNo">
                                <el-input v-model="forms.externalNo" :disabled="isView" style="width:220px"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8">
                            <el-form-item label="建议供应商" prop="suggestSupplierCode">
                                <el-select v-model="forms.suggestSupplierCode" filterable clearable placeholder="请选择供应商"
                                    :disabled="isView" style="width:220px" @change="(value) => {
                                        const selected = suppliers.find(s => s.supplierCode === value);
                                        forms.suggestSupplierName = selected ? selected.supplierName : '';
                                    }">
                                    <el-option v-for="s in suppliers" :key="s.supplierCode"
                                        :label="s.supplierName || s.text" :value="s.supplierCode"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :xs="24">
                            <el-form-item label="金料汇总">
                                <el-input :model-value="goldSummaryText" type="textarea" :rows="2" disabled style="width:95%" />
                            </el-form-item>
                            <el-form-item label="备注" prop="remark">
                                <el-input v-model="forms.remark" type="textarea" :rows="2" :disabled="isView"
                                    style="width:95%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>

            <el-tab-pane label="附件" name="attachment">
                <div class="attachments-pane">
                    <el-alert
                        type="info"
                        show-icon
                        title="附件通过申请单号关联，请确保已生成申请单号后再上传"
                        class="attachments-alert"
                    />
                    <el-upload
                        class="attachments-uploader"
                        :action="uploadAction"
                        list-type="picture-card"
                        :file-list="fileList"
                        :on-success="handleAttachmentUploadSuccess"
                        :before-upload="handleAttachmentBeforeUpload"
                        :on-preview="handleAttachmentPreview"
                        :disabled="isView"
                        accept="*/*"
                    >
                        <el-icon>
                            <Plus />
                        </el-icon>
                        <template #file="{ file }">
                            <div>
                                <img
                                    v-if="['jpg','jpeg','png','bmp'].includes((file.ext || '').toLowerCase())"
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url"
                                    alt=""
                                />
                                <div v-else class="attachments-file-text">
                                    <span>{{ file.name }}</span>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span
                                        class="el-upload-list__item-preview"
                                        @click="handleAttachmentPreview(file)"
                                        title="预览"
                                    >
                                        <el-icon>
                                            <ZoomIn />
                                        </el-icon>
                                    </span>
                                    <span
                                        class="el-upload-list__item-delete"
                                        @click="handleAttachmentDownload(file)"
                                        title="下载"
                                    >
                                        <el-icon>
                                            <Download />
                                        </el-icon>
                                    </span>
                                    <span
                                        v-if="!isView"
                                        class="el-upload-list__item-delete"
                                        @click="handleAttachmentRemove(file)"
                                        title="删除"
                                    >
                                        <el-icon>
                                            <Delete />
                                        </el-icon>
                                    </span>
                                </span>
                            </div>
                        </template>
                    </el-upload>
                    <el-empty v-if="!fileList.length && !forms.billCode" description="暂无附件，待申请单号生成后可上传" />
                </div>
            </el-tab-pane>

        </el-tabs>

        <div style="text-align:left; margin-top: 20px;">
            <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
            <el-button icon="Back" @click="back">返回</el-button>
        </div>

        <div style="margin-top: 15px;">
            <el-card>
                <template #header>
                    <div style="display:flex;align-items:center;justify-content:space-between;">
                        <div>采购申请单明细</div>
                        <div>
                            <el-button plain icon="Plus" type="primary" size="small" @click="addDetail" v-if="!isView">
                                新增明细
                            </el-button>

                            <el-dropdown v-if="!isView" style="margin:0px 10px;" size="small">
                                <el-button plain icon="Upload" type="primary" size="small">
                                    数据操作
                                </el-button>
                                <template #dropdown>
                                    <el-dropdown-menu>
                                        <el-dropdown-item>导入明细</el-dropdown-item>
                                        <el-dropdown-item @click="downloadTemplate">下载模板</el-dropdown-item>
                                    </el-dropdown-menu>
                                </template>
                            </el-dropdown>
                        </div>
                    </div>
                </template>

                <el-empty v-if="!details.length" description="暂无采购申请明细">
                    <el-button v-if="!isView" type="primary" plain icon="Plus" @click="addDetail">新增明细</el-button>
                </el-empty>

                <el-collapse v-else v-model="activeDetailKey" accordion class="detail-collapse">
                    <el-collapse-item v-for="(detail, index) in details" :key="detail._formKey" :name="detail._formKey">
                        <template #title>
                            <div class="detail-card-title">
                                <span class="detail-index">明细 {{ index + 1 }}</span>
                                <el-image v-if="detail.detailCode" class="detail-title-image"
                                    :src="apiUrl + 'static/code/' + detail.detailCode + '?t=0'" fit="cover">
                                    <template #error><img src="~@/assets/imgunfine.jpg" alt="" /></template>
                                </el-image>
                                <div class="detail-title-product">
                                    <strong>{{ detail.productName || '未选择货品' }}</strong>
                                    <span>{{ detail.productSearchText || detail.detailCode || '待选择 SKU' }}</span>
                                </div>
                                <el-tag v-if="detail.channel" class="detail-title-channel" size="small" effect="plain">{{ detail.channel }}</el-tag>
                                <span class="detail-title-metric">数量：{{ detail.requiredQuantity || 0 }}</span>
                                <span class="detail-title-metric detail-title-amount">金额：¥{{ formatAmount(detail.estimatedAmount) }}</span>
                                <el-tag class="detail-title-status" size="small" :type="detail.goldSettlementStatus === 'not_involved' ? 'info' : 'warning'">
                                    {{ goldStatusLabel(detail.goldSettlementStatus) }}
                                </el-tag>
                                <span v-if="!isView" class="detail-title-delete" role="button" tabindex="0"
                                    @click.stop="deleteDetailRow(index)" @keydown.enter.stop="deleteDetailRow(index)">删除</span>
                            </div>
                        </template>

                        <el-form :model="detail" label-position="right" label-width="120px" size="small" class="detail-form">
                            <el-tabs v-model="detail._activeSection" class="detail-section-tabs">
                                <el-tab-pane label="货品信息" name="product">
                                    <div class="detail-tab-pane">
                                        <el-row :gutter="12">
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'channel')">
                                        <el-form-item label="备货渠道" required>
                                            <el-select v-model="detail.channel" filterable placeholder="请选择备货渠道" :disabled="isView"
                                                style="width:100%" @change="() => onChannelChange(detail)">
                                                <el-option v-for="item in channels" :key="item.value" :label="item.label || item.name" :value="item.value || item.name" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'detailId')">
                                        <el-form-item label="SKU选择" required>
                                            <el-autocomplete v-model="detail.productSearchText"
                                                :fetch-suggestions="(queryString, cb) => searchProductAsync(queryString, cb, detail)"
                                                placeholder="输入编号、名称或条码" :disabled="Boolean(detail.id) || isView"
                                                @select="item => handleProductSelect(item, detail)" style="width:100%"
                                                :trigger-on-focus="false" :debounce="300">
                                                <template #default="{ item }">
                                                    <div class="sku-suggestion">
                                                        <span>{{ item.detailCode }}</span>
                                                        <span>{{ item.serialCode }}</span>
                                                        <span>{{ item.detailName }}</span>
                                                    </div>
                                                </template>
                                            </el-autocomplete>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="货品图片">
                                            <div class="detail-product-image">
                                                <el-image v-if="detail.detailCode" lazy
                                                    :src="apiUrl + 'static/code/' + detail.detailCode + '?t=0'"
                                                    :preview-src-list="[apiUrl + 'static/code/' + detail.detailCode + '?t=1']">
                                                    <template #error><img src="~@/assets/imgunfine.jpg" alt="" /></template>
                                                </el-image>
                                                <span v-else>选择 SKU 后显示</span>
                                            </div>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="品牌款号">
                                            <el-input :model-value="detail.productBarcode || '-'" disabled />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'productName')">
                                        <el-form-item label="货品名称" required>
                                            <el-input v-model="detail.productName" :disabled="isSkuFieldDisabled(detail, 'productName')" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'unitName')">
                                        <el-form-item label="单位" required>
                                            <el-input v-model="detail.unitName" :disabled="isView" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="备货品牌">
                                            <el-input v-if="!detail.brandCode && detail.brandName" v-model="detail.brandName"
                                                :disabled="isView || Boolean(detail._skuLockedFields?.brandCode)" />
                                            <el-select v-else v-model="detail.brandCode" filterable clearable
                                                :placeholder="detail.brandName || '请选择品牌'"
                                                :disabled="isSkuFieldDisabled(detail, 'brandCode')" style="width:100%"
                                                @change="value => onBrandChange(detail, value)">
                                                <el-option v-for="b in brands" :key="b.id || b.brandCode"
                                                    :label="b.brandName || b.BrandName" :value="b.brandCode || b.BrandCode" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="工厂款号">
                                            <el-input v-model="detail.supplierProductCode" :disabled="isSkuFieldDisabled(detail, 'supplierProductCode')" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="规格尺寸">
                                            <el-input v-model="detail.productSpec" :disabled="isSkuFieldDisabled(detail, 'productSpec')" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="金重范围">
                                            <el-input v-model="detail.weightRange" :disabled="isSkuFieldDisabled(detail, 'weightRange')" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="字印">
                                            <el-input v-model="detail.stampText" :disabled="isView" />
                                        </el-form-item>
                                    </el-col>
                                        </el-row>
                                    </div>
                                </el-tab-pane>

                                <el-tab-pane label="采购申请" name="purchase">
                                    <div class="detail-tab-pane">
                                        <el-row :gutter="12">
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'requiredQuantity')">
                                        <el-form-item label="申请备货数量" required>
                                            <el-input-number v-model="detail.requiredQuantity" :disabled="isView"
                                                @change="onQuantityOrPriceChange(detail)" :precision="4" :min="0" style="width:100%" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'hasReport')">
                                        <el-form-item label="是否有报告" required>
                                            <el-select v-model="detail.hasReport" placeholder="请选择" :disabled="isView" style="width:100%">
                                                <el-option label="是" :value="true" /><el-option label="否" :value="false" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'estimatedPrice')">
                                        <el-form-item label="预计入库成本价">
                                            <el-input-number v-model="detail.estimatedPrice" :disabled="isView"
                                                @change="onQuantityOrPriceChange(detail)" :precision="4" :min="0" style="width:100%" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="备货金额合计">
                                            <el-input :model-value="'¥' + formatAmount(detail.estimatedAmount)" disabled />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'suggestSupplierCode')">
                                        <el-form-item label="供应商名称">
                                            <el-input v-if="!detail.suggestSupplierCode && detail.suggestSupplierName"
                                                v-model="detail.suggestSupplierName"
                                                :disabled="isView || Boolean(detail._skuLockedFields?.suggestSupplierCode)" />
                                            <el-select v-else v-model="detail.suggestSupplierCode" filterable clearable
                                                :placeholder="detail.suggestSupplierName || '请选择供应商'"
                                                :disabled="isSkuFieldDisabled(detail, 'suggestSupplierCode')" style="width:100%"
                                                @change="value => onSupplierChange(detail, value)">
                                                <el-option v-for="s in suppliers" :key="s.supplierCode"
                                                    :label="s.supplierName || s.text" :value="s.supplierCode" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'minOrderQty')">
                                        <el-form-item label="工厂最低起订量">
                                            <el-input-number v-model="detail.minOrderQty" :disabled="isView" :precision="4" :min="0" style="width:100%" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="按工厂最低起订量下单">
                                            <el-select v-model="detail.acceptMinQty" clearable :disabled="isView" style="width:100%">
                                                <el-option label="是" :value="true" /><el-option label="否" :value="false" />
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="备货原因">
                                            <el-input v-model="detail.purchaseReason" :disabled="isView" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="预估/计划售完时间">
                                            <el-date-picker v-model="detail.sellOutDate" type="date" :disabled="isView"
                                                format="YYYY-MM-DD" style="width:100%" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="12" :lg="8">
                                        <el-form-item label="要求到货">
                                            <el-date-picker v-model="detail.requiredDate" type="date" :disabled="isView"
                                                format="YYYY-MM-DD" style="width:100%" />
                                        </el-form-item>
                                    </el-col>
                                    <el-col :xs="24" :sm="24" :lg="16">
                                        <el-form-item label="申请备注">
                                            <el-input v-model="detail.remark" type="textarea" :rows="2" :disabled="isView" />
                                        </el-form-item>
                                    </el-col>
                                        </el-row>
                                    </div>
                                </el-tab-pane>

                                <el-tab-pane label="销量与库存" name="inventory">
                                    <div class="detail-tab-pane">
                                    <div class="detail-section-heading">
                                        <span class="detail-tab-hint">最近30天销量及部门库存快照</span>
                                        <el-tooltip v-if="!isView" content="抓取同公司、同渠道、同SKU最近30天销量及本部门、其他部门可用库存" placement="top">
                                            <el-button link type="primary" icon="Refresh" :loading="salesAndStockRefreshing"
                                                @click="refreshSalesAndStock({ row: detail })">刷新本条数据</el-button>
                                        </el-tooltip>
                                    </div>
                                    <el-row :gutter="12">
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'monthSalesQty')">
                                            <el-form-item label="近1个月销量"><el-input-number v-model="detail.monthSalesQty" :disabled="isView" :precision="4" :min="0" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col v-for="column in snapshotQtyColumns" :key="column.prop" :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, column.prop)">
                                            <el-form-item :label="column.label"><el-input-number v-model="detail[column.prop]" :disabled="isView" :precision="4" :min="0" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'nonFinishedQty')">
                                            <el-form-item label="非成品库库存数量"><el-input-number v-model="detail.nonFinishedQty" :disabled="isView" :precision="4" :min="0" style="width:100%" /></el-form-item>
                                        </el-col>
                                    </el-row>
                                    </div>
                                </el-tab-pane>

                                <el-tab-pane label="排期与跟单" name="schedule">
                                    <div class="detail-tab-pane">
                                    <el-row :gutter="12">
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'orderDate')">
                                            <el-form-item label="下单时间"><el-date-picker v-model="detail.orderDate" type="date" :disabled="isView" @change="recalculateSchedule(detail)" format="YYYY-MM-DD" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'leadDays')">
                                            <el-form-item label="工期（天）"><el-input-number v-model="detail.leadDays" :disabled="isSkuFieldDisabled(detail, 'leadDays')" @change="recalculateSchedule(detail)" :precision="0" :min="0" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'estShipDate')">
                                            <el-form-item label="预计出货时间"><el-date-picker v-model="detail.estShipDate" type="date" :disabled="isView" format="YYYY-MM-DD" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'qcLeadDays')">
                                            <el-form-item label="质检做证等工期（天）"><el-input-number v-model="detail.qcLeadDays" :disabled="isSkuFieldDisabled(detail, 'qcLeadDays')" @change="recalculateSchedule(detail, false)" :precision="0" :min="0" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'estInboundDate')">
                                            <el-form-item label="预计入库时间"><el-date-picker v-model="detail.estInboundDate" type="date" :disabled="isView" format="YYYY-MM-DD" style="width:100%" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8">
                                            <el-form-item label="跟单备注"><el-input v-model="detail.followRemark" :disabled="isView" /></el-form-item>
                                        </el-col>
                                    </el-row>
                                    </div>
                                </el-tab-pane>

                                <el-tab-pane label="金料处理" name="gold">
                                    <div class="detail-tab-pane">
                                    <el-row :gutter="12">
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'goldMaterialCode')">
                                            <el-form-item label="金料材质">
                                                <el-select v-model="detail.goldMaterialCode" clearable :disabled="isView" placeholder="不含金可留空" style="width:100%" @change="value => onGoldMaterialChange(detail, value)">
                                                    <el-option v-for="m in metals" :key="m.name" :label="m.value || m.name" :value="m.name" />
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8">
                                            <el-form-item label="预计金重(g)"><el-input-number v-model="detail.estimatedGoldWeight" :min="0" :precision="4" :disabled="isView" style="width:100%" @change="markGoldWeightManual(detail)" /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'goldShortageAction')">
                                            <el-form-item label="缺料处理">
                                                <el-select v-model="detail.goldShortageAction" :disabled="isView" style="width:100%" @change="value => onGoldShortageAction(detail, value)">
                                                    <el-option label="先补金料" value="replenish" /><el-option label="允许供应商欠料" value="supplier_debt" />
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8" :id="detailFieldId(detail, 'provisionalGoldPrice')">
                                            <el-form-item label="欠料预估金价">
                                                <el-input-number v-model="detail.provisionalGoldPrice" :min="0" :precision="4" :disabled="isView || !detail.allowSupplierGoldDebt" style="width:100%" />
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8">
                                            <el-form-item label="金料状态"><el-input :model-value="goldStatusLabel(detail.goldSettlementStatus)" disabled /></el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="12" :lg="8">
                                            <el-form-item label="库存预览">
                                                <div class="gold-availability">
                                                    <span>{{ goldAvailabilityLabel(detail) }}</span>
                                                    <el-button v-if="detail.goldAvailabilityStatus === 'shortage' && detail.goldShortageAction === 'replenish'"
                                                        link type="primary" @click="openGoldWorkbench(detail)">去补金料</el-button>
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </el-form>
                    </el-collapse-item>
                </el-collapse>
            </el-card>
        </div>

    </el-card>
</template>

<script>
import { fetchBillCode, fetchPurchaseSupplier, fetchPurchaseBrand, refreshRequisitionSalesAndStock, previewRequisitionGoldAvailability } from '@/api/purchase'
import { searchSkuList, fetchSpuDetail } from '@/api/product'
import { fetchFileList, delFile } from '@/api/basic'
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue'

export default {
    name: 'PurchaseRequisitionBill',
    components: {
        Plus,
        ZoomIn,
        Download,
        Delete
    },
    data() {
        return {
            apiUrl: '',
            activeTab: 'basic',
            companys: [],
            departments: [],
            suppliers: [],
            brands: [],
            channels: [],
            metals: [],
            fileList: [],
            salesAndStockRefreshing: false,
            salesAndStockPreviewTimer: null,
            goldPreviewTimer: null,
            activeDetailKey: '',
            detailKeySeed: 0,

            snapshotQtyColumns: [
                { prop: 'deptStockQty', label: '本部门现有库存数量', width: 160 },
                { prop: 'otherDeptStockQty', label: '其他部门现有库存数量', width: 170 },
                { prop: 'transferQty', label: '可支持调拨数量', width: 150 }
            ],

            details: [],
            forms: {
                billDate: new Date(),
                applicantDate: new Date(),
                status: 0,
                totalQuantity: 0,
                totalAmount: 0,
                companyID: '',
                companyName: '',
                departmentID: '',
                departmentName: '',
                billCode: '',
                billType: '',
                externalNo: '',
                suggestSupplierCode: '',
                suggestSupplierName: ''
            },
            // 表单校验规则
            rules: {
                billCode: [
                    { required: true, message: '申请单号不能为空', trigger: 'blur' }
                ],
                billType: [
                    { required: true, message: '请选择单据类型', trigger: 'change' }
                ],
                billDate: [
                    { required: true, message: '请选择制单日期', trigger: 'change' }
                ],
                applicantDate: [
                    { required: true, message: '请选择申请日期', trigger: 'change' }
                ],
                companyID: [
                    { required: true, message: '请选择所属公司', trigger: 'change' }
                ],
                departmentID: [
                    { required: true, message: '请选择申请部门', trigger: 'change' }
                ],
                applicantName: [
                    { required: true, message: '请输入申请人', trigger: 'blur' },
                    { min: 2, max: 50, message: '申请人长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                requirementDate: [
                    { required: true, message: '请选择需求日期', trigger: 'change' }
                ]
            },
        }
    },
    computed: {
        isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view' },
        isView() { return this.$route.query.mode === 'view' },
        requisitionId() { return this.$route.query.id },
        uploadAction() {
            const code = this.forms.billCode || ''
            return `${this.apiUrl}BaseUploader/Basic?dataType=PurchaseRequisition&dataID=${code}&fileType=form&fileCode=${code}`
        },
        goldSummaryText() {
            return this.buildGoldSummary(this.details, false)
        }
    },
    mounted() {
        this.apiUrl = process.env.VUE_APP_BASEURL;
        this.$kaung.init(this.$options.name);

        this.$kaung.companys().then((res) => {
            this.companys = res;
            this.companyChange();
        });

        fetchPurchaseSupplier().then((res) => {
            if (res && res.code === 200) {
                this.suppliers = Array.isArray(res.data) ? res.data : []
                this.details.forEach(detail => this.ensureSupplierOption(detail.suggestSupplierCode, detail.suggestSupplierName))
            }
        });

        // 加载品牌列表
        fetchPurchaseBrand().then((res) => {
            if (res && res.code === 200) {
                this.brands = Array.isArray(res.data) ? res.data : []
                this.details.forEach(detail => this.ensureBrandOption(detail.brandCode, detail.brandName))
            }
        });

        this.$kaung.dictionary("stock", "channel").then(res => {
            this.channels = Array.isArray(res) ? res : []
        });
        this.$kaung.dictionary("stock", "metal").then(res => {
            this.metals = Array.isArray(res) ? res : []
        });

        if (this.requisitionId) {
            this.load();
        } else {
            fetchBillCode(this.$options.name).then(res => {
                this.forms.billCode = res.data || '';
                this.forms.billType = '常规采购';
                this.forms.applicantName = this.$store.getters.getUserInfo.realName || this.$store.getters.getUserInfo.userName || '';
                //console.log('getUserInfo', this.$store.getters.getUserInfo)
                this.forms.companyID = this.$store.getters.getUserInfo.companyID || '';
                this.forms.departmentID = this.$store.getters.getUserInfo.departmentID || ''
                this.companyChange(this.forms.departmentID);
                this.loadAttachments();
            })
        }
    },
    methods: {
        /** 将采购链路中的金料结算状态转换为业务人员可读文本。 */
        goldStatusLabel(status) {
            const labels = {
                not_involved: '未涉及',
                pending_reservation: '待审核锁定',
                reserved: '已锁定',
                deducted: '已扣减',
                partial_debt: '部分欠料',
                debt: '欠料',
                settled: '已结清',
                released: '已释放'
            }
            return labels[status] || (status || '未涉及')
        },
        // 搜索货品信息
        searchProductAsync(queryString, callback, row) {
            if (!queryString || queryString.trim().length < 2) {
                callback([]);
                return;
            }

            searchSkuList(queryString).then(res => {
                if (res && res.data && res.data.data) {
                    const suggestions = res.data.data;
                    callback(suggestions);
                } else {
                    callback([]);
                }
            }).catch(err => {
                console.error('Product search error:', err);
                callback([]);
            });
        },
        // 选择货品后填充信息
        async handleProductSelect(item, row) {
            if (!item) return;

            const productSpec = this.buildProductSpec(item)
            row._skuLockedFields = {
                productCode: Boolean(item.productCode),
                productName: Boolean(item.detailName),
                brandCode: Boolean(item.brandCode || item.brandName),
                supplierProductCode: Boolean(item.factoryModelCode),
                weightRange: Boolean(item.weightRange),
                productSpec: Boolean(productSpec),
                suggestSupplierCode: Boolean(item.factoryCode || item.factoryName),
                leadDays: item.factoryDeliveryCycleDays !== null && item.factoryDeliveryCycleDays !== undefined,
                qcLeadDays: item.inboundCycleDays !== null && item.inboundCycleDays !== undefined
            }

            row.productId = item.productID || '';
            row.productCode = item.productCode || '';
            row.productName = item.detailName || '';
            row.productSpec = productSpec;
            row.weightRange = item.weightRange || '';
            row.productBarcode = item.brandModelCode || '';
            row.detailId = item.id || '';
            row.detailCode = item.detailCode || '';
            row.detailName = item.detailName || '';

            // 设置搜索文本为货品编号，便于显示和编辑
            row.productSearchText = item.detailCode || item.serialCode || item.brandModelCode || item.factoryModelCode || '';

            row.suggestSupplierCode = item.factoryCode || '';
            row.suggestSupplierName = item.factoryName || '';
            row.supplierProductCode = item.factoryModelCode || '';
            row.brandCode = item.brandCode || '';
            row.brandName = item.brandName || '';
            this.ensureBrandOption(row.brandCode, row.brandName)
            this.ensureSupplierOption(row.suggestSupplierCode, row.suggestSupplierName)
            row.estimatedPrice = item.purchasePrice ?? null;
            row.leadDays = item.factoryDeliveryCycleDays ?? null;
            row.qcLeadDays = item.inboundCycleDays ?? null;
            row.goldMaterialCode = item.metalCode || '';
            row.stampText = item.stampText || '';
            row._skuStandardWeight = Number(item.standardWeight) || 0;
            row._goldWeightMode = 'sku';
            row.estimatedGoldWeight = Number((row._skuStandardWeight * (Number(row.requiredQuantity) || 0)).toFixed(4));
            row.goldSettlementStatus = row.goldMaterialCode && row.estimatedGoldWeight > 0 ? 'pending_reservation' : 'not_involved';

            const selectedDetailID = row.detailId;
            try {
                const spu = item.productID ? await fetchSpuDetail(item.productID) : null;
                if (row.detailId === selectedDetailID) row.unitName = spu?.data?.productUnit || '件';
            } catch (_) {
                if (row.detailId === selectedDetailID) row.unitName = '件';
            }

            this.onQuantityOrPriceChange(row)
            this.recalculateSchedule(row)
            this.scheduleGoldPreview()
            this.scheduleSalesAndStockRefresh(row)

            this.$message.success('货品信息已填充');
        },
        load() {
            this.$kaung.getone(this.requisitionId).then(res => {
                if (res.code === 200) {
                    this.forms = { ...res.data };
                    this.forms.applicantDate = this.forms.applicantDate || this.forms.billDate || new Date()
                    this.companyChange(this.forms.departmentID);
                    this.loadAttachments();
                }
            });

            this.fetchDetails();
        },
        fetchDetails() {
            this.$kaung.fetch({ url: 'PurchaseRequisitionDetail/GetDetailList', params: { billId: this.requisitionId }, method: 'get' })
                .then(res => {
                    if (res && res.code === 200) {
                        this.details = Array.isArray(res.data) ? res.data : [];
                        this.details.forEach(detail => {
                            detail.productSearchText = detail.detailCode;
                            detail._isNew = false;
                            detail._skuLockedFields = {};
                            detail._goldWeightMode = 'manual';
                            detail.goldShortageAction = detail.allowSupplierGoldDebt ? 'supplier_debt' : 'replenish';
                            this.ensureDetailUiState(detail)
                            this.ensureBrandOption(detail.brandCode, detail.brandName)
                            this.ensureSupplierOption(detail.suggestSupplierCode, detail.suggestSupplierName)
                        });
                        this.activeDetailKey = this.details[0]?._formKey || ''
                    }
                })
        },
        // 同步附件列表，确保文件与申请单号绑定
        loadAttachments() {
            const billCode = this.forms.billCode
            if (!billCode) {
                this.fileList = []
                return
            }

            fetchFileList(billCode).then(res => {
                if (res && res.code === 200) {
                    this.fileList = Array.isArray(res.data) ? res.data : []
                }
            })
        },
        handleAttachmentBeforeUpload() {
            if (!this.forms.billCode) {
                this.$message.warning('请先生成申请单号后再上传附件')
                return false
            }
            return true
        },
        handleAttachmentUploadSuccess(res) {
            if (res && res.code === 200) {
                this.$message.success(res.content || '上传成功')
                this.loadAttachments()
            } else {
                this.$message.error(res?.content || '上传失败')
            }
        },
        handleAttachmentPreview(file) {
            if (file && file.id) {
                window.open('/preview?id=' + file.id)
            } else if (file && file.url) {
                window.open(file.url)
            }
        },
        handleAttachmentDownload(file) {
            if (file && file.url) {
                window.open(file.url)
            }
        },
        handleAttachmentRemove(file) {
            if (!file || !file.id) {
                return
            }

            this.$confirm('确定要删除该附件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(file.id).then(res => {
                    if (res && res.code === 200) {
                        this.$message.success(res.content || '删除成功')
                        this.loadAttachments()
                    } else {
                        this.$message.error(res?.content || '删除失败')
                    }
                })
            }).catch(() => { })
        },
        addDetail() {
            const newDetail = {
                id: null,
                billId: this.requisitionId || '',
                channel: this.getDefaultChannel(),
                productCode: '',
                productBarcode: '',
                productName: '',
                unitName: '件',
                weightRange: '',
                requiredQuantity: 0,
                estimatedPrice: null,
                estimatedAmount: 0,
                monthSalesQty: null,
                deptStockQty: null,
                otherDeptStockQty: null,
                transferQty: null,
                minOrderQty: null,
                acceptMinQty: null,
                sellOutDate: null,
                hasReport: false,
                nonFinishedQty: null,
                orderDate: null,
                leadDays: null,
                estShipDate: null,
                qcLeadDays: null,
                estInboundDate: null,
                requiredDate: null,
                remark: '',
                followRemark: '',
                stampText: '',
                goldMaterialCode: '',
                estimatedGoldWeight: null,
                allowSupplierGoldDebt: false,
                provisionalGoldPrice: null,
                goldSettlementStatus: 'not_involved',
                goldShortageAction: 'replenish',
                goldAvailabilityStatus: '',
                _skuLockedFields: {},
                _isNew: true
            }

            this.ensureDetailUiState(newDetail)
            this.details.push(newDetail)
            this.activeDetailKey = newDetail._formKey
            this.$nextTick(() => {
                const target = document.getElementById(this.detailFieldId(newDetail, 'detailId'))
                target?.scrollIntoView({ behavior: 'smooth', block: 'center' })
            })
        },
        editDetail(row) {
            const detailId = row && row.id ? row.id : 'add'
            this.$router.push({ name: 'PurchaseRequisitionDetail', query: { id: this.requisitionId, detail: detailId } })
        },

        submit() {
            // 首先验证表单
            this.$refs.forms.validate((valid) => {
                if (!valid) {
                    this.$message.error('请完善必填信息');
                    return false;
                }

                // 验证明细数据
                if (!this.details || this.details.length === 0) {
                    this.$message.error('请至少添加一条采购明细');
                    return false;
                }

                // 验证明细必填字段，并展开、定位到第一处错误
                for (let i = 0; i < this.details.length; i++) {
                    const detail = this.details[i];
                    const validation = this.validateDetail(detail, i)
                    if (validation) {
                        this.revealDetailValidation(detail, validation)
                        return false;
                    }
                    this.onQuantityOrPriceChange(detail)
                }

                // 提交数据
                this.syncGoldSummaryRemark()
                this.$kaung.post({ url: '/' + this.$options.name + '/PostForms', data: { master: this.forms, details: this.buildSubmitDetails() } }).then(res => {
                    if (res.code === 200) {
                        this.$message({ message: res.content, type: res.type });
                        this.back();
                    }
                }).catch(err => {
                    this.$message.error('提交失败：' + (err.message || '未知错误'));
                });
            });
        },
        back() { this.$router.back() },

        companyChange(departmentID) {
            this.forms.departmentID = departmentID || '';
            this.departments = [];
            var that = this;
            if (this.forms.companyID) {
                this.$kaung.departments(this.forms.companyID).then((res) => {
                    that.departments = res;
                    if (that.forms.departmentID) {
                        that.forms.departmentName = that.findTreeLabel(res, that.forms.departmentID) || that.forms.departmentName
                    }
                });
            }
        },

        onQuantityOrPriceChange(row) {
            const quantity = Number(row.requiredQuantity) || 0
            const price = Number(row.estimatedPrice) || 0
            row.estimatedAmount = Number((quantity * price).toFixed(4))
            if (row._goldWeightMode === 'sku') {
                row.estimatedGoldWeight = Number(((Number(row._skuStandardWeight) || 0) * quantity).toFixed(4))
                row.goldSettlementStatus = row.goldMaterialCode && row.estimatedGoldWeight > 0 ? 'pending_reservation' : 'not_involved'
            }
            this.scheduleGoldPreview()
        },

        markGoldWeightManual(row) {
            row._goldWeightMode = 'manual'
            row.goldSettlementStatus = row.goldMaterialCode && Number(row.estimatedGoldWeight) > 0 ? 'pending_reservation' : 'not_involved'
            this.scheduleGoldPreview()
        },
        onGoldMaterialChange(row) {
            row.goldAvailabilityStatus = ''
            row.goldSettlementStatus = row.goldMaterialCode && Number(row.estimatedGoldWeight) > 0 ? 'pending_reservation' : 'not_involved'
            this.scheduleGoldPreview()
        },
        onGoldShortageAction(row, value) {
            row.allowSupplierGoldDebt = value === 'supplier_debt'
        },
        scheduleGoldPreview() {
            clearTimeout(this.goldPreviewTimer)
            this.goldPreviewTimer = setTimeout(() => this.refreshGoldAvailability(), 300)
        },
        refreshGoldAvailability() {
            if (!this.forms.companyID || !this.forms.departmentID) return
            const items = this.details.map((detail, index) => ({
                rowKey: String(index), materialCode: detail.goldMaterialCode,
                requestedQuantity: Number(detail.estimatedGoldWeight) || 0
            })).filter(item => item.materialCode && item.requestedQuantity > 0)
            if (!items.length) return
            previewRequisitionGoldAvailability(this.forms.companyID, this.forms.departmentID, items).then(res => {
                const rows = res?.data?.rows || []
                rows.forEach(item => Object.assign(this.details[Number(item.rowKey)] || {}, {
                    goldAvailabilityStatus: item.status,
                    goldAvailableQuantity: item.availableQuantity,
                    goldPreviewOwnQuantity: item.ownQuantity,
                    goldPreviewDebtQuantity: item.debtQuantity
                }))
            })
        },
        goldAvailabilityLabel(row) {
            if (!row.goldMaterialCode || !(Number(row.estimatedGoldWeight) > 0)) return '不涉及'
            if (row.goldAvailabilityStatus === 'account_missing') return '账户未启用'
            if (row.goldAvailabilityStatus === 'shortage') return `预计缺料 ${Number(row.goldPreviewDebtQuantity || 0).toFixed(4)}g`
            if (row.goldAvailabilityStatus === 'sufficient') return `预计充足（可用 ${Number(row.goldAvailableQuantity || 0).toFixed(4)}g）`
            return '待预览'
        },
        openGoldWorkbench(row) {
            const target = this.$router.resolve({ name: 'GoldMaterialWorkbench', query: {
                companyID: this.forms.companyID, departmentID: this.forms.departmentID,
                materialCode: row.goldMaterialCode, tab: 'accounts'
            } })
            window.open(target.href, '_blank')
        },

        refreshSalesAndStock(options = {}) {
            const silent = options && options.silent === true
            const onlyRow = options && options.row
            if (this.salesAndStockRefreshing) return
            if (!this.forms.companyID) {
                if (!silent) this.$message.warning('请先选择所属公司')
                return
            }

            const items = []
            let skippedCount = 0
            this.details.forEach((detail, index) => {
                if (onlyRow && detail !== onlyRow) return
                if (!detail.detailCode || !detail.channel) {
                    skippedCount++
                    return
                }
                items.push({
                    rowKey: String(index),
                    detailCode: detail.detailCode,
                    channel: detail.channel
                })
            })

            if (!items.length) {
                if (!silent) this.$message.warning('没有可刷新的明细，请先选择SKU和备货渠道')
                return
            }

            this.salesAndStockRefreshing = true
            refreshRequisitionSalesAndStock(this.forms.companyID, items).then(res => {
                if (!res || res.code !== 200) {
                    if (!silent) this.$message.error(res?.content || '刷新近30天销量及部门库存失败')
                    return
                }

                const results = Array.isArray(res.data) ? res.data : []
                results.forEach(item => {
                    const index = Number(item.rowKey)
                    if (Number.isInteger(index) && this.details[index]) {
                        this.details[index].monthSalesQty = Number(item.monthSalesQty) || 0
                        this.details[index].deptStockQty = Number(item.deptStockQty) || 0
                        this.details[index].otherDeptStockQty = Number(item.otherDeptStockQty) || 0
                    }
                })

                const skippedText = skippedCount ? `，已跳过 ${skippedCount} 行未选SKU或渠道的明细` : ''
                if (!silent) this.$message.success(`已刷新 ${results.length} 行近30天销量及部门库存${skippedText}`)
            }).catch(err => {
                console.error('刷新采购申请近30天销量及部门库存失败:', err)
                if (!silent) this.$message.error('刷新近30天销量及部门库存失败，原有数据已保留')
            }).finally(() => {
                this.salesAndStockRefreshing = false
            })
        },

        isSkuFieldDisabled(row, field) {
            return this.isView || Boolean(row.id) || Boolean(row._skuLockedFields && row._skuLockedFields[field])
        },

        buildProductSpec(item) {
            const parts = []
            const detailUnit = (item.detailUnit || '').trim()
            if (detailUnit) parts.push(detailUnit)
            if (item.productSize !== null && item.productSize !== undefined && item.productSize !== '') {
                const size = `${Number(item.productSize)}${item.productSizeUnit || ''}`
                if (!parts.some(part => part.toLowerCase() === size.toLowerCase())) parts.push(size)
            }
            return parts.join(' / ')
        },

        onBrandChange(row, value) {
            const selected = this.brands.find(item => (item.brandCode || item.BrandCode) === value)
            row.brandName = selected ? (selected.brandName || selected.BrandName || '') : ''
        },

        onSupplierChange(row, value) {
            const selected = this.suppliers.find(item => item.supplierCode === value)
            row.suggestSupplierName = selected ? (selected.supplierName || selected.text || '') : ''
        },

        ensureBrandOption(code, name) {
            if (!code || this.brands.some(item => (item.brandCode || item.BrandCode) === code)) return
            this.brands.push({ id: `sku-brand-${code}`, brandCode: code, brandName: name || code })
        },
        ensureSupplierOption(code, name) {
            if (!code || this.suppliers.some(item => (item.supplierCode || item.SupplierCode) === code)) return
            this.suppliers.push({ id: `sku-supplier-${code}`, supplierCode: code, supplierName: name || code })
        },

        onChannelChange(row) {
            row.monthSalesQty = null
            row.deptStockQty = null
            row.otherDeptStockQty = null
            row.transferQty = null
            this.scheduleSalesAndStockRefresh(row)
            this.scheduleGoldPreview()
        },
        scheduleSalesAndStockRefresh(row) {
            clearTimeout(this.salesAndStockPreviewTimer)
            this.salesAndStockPreviewTimer = setTimeout(() => this.refreshSalesAndStock({ silent: true, row }), 300)
        },

        buildGoldSummary(details, includeActual) {
            const groups = new Map()
            ;(details || []).filter(item => !item.deleteMark && item.goldMaterialCode).forEach(item => {
                const code = item.goldMaterialCode
                const current = groups.get(code) || { estimated: 0, actual: 0, own: 0, debt: 0 }
                current.estimated += Number(item.estimatedGoldWeight) || 0
                current.actual += Number(item.actualGoldWeight) || 0
                current.own += Number(item.ownGoldWeight || item.goldPreviewOwnQuantity) || 0
                current.debt += Number(item.supplierDebtGoldWeight || item.goldPreviewDebtQuantity) || 0
                groups.set(code, current)
            })
            if (!groups.size) return '不涉及金料'
            return Array.from(groups.entries()).map(([code, value]) => {
                const actual = includeActual ? `，实际 ${value.actual.toFixed(4)}g` : ''
                return `${code}：预计 ${value.estimated.toFixed(4)}g${actual}，自有 ${value.own.toFixed(4)}g，欠料 ${value.debt.toFixed(4)}g`
            }).join('；')
        },
        syncGoldSummaryRemark() {
            const clean = String(this.forms.remark || '').replace(/(?:^|\n)\[金料汇总\][^\n]*/g, '').trim()
            this.forms.remark = this.goldSummaryText === '不涉及金料'
                ? clean : [clean, `[金料汇总] ${this.goldSummaryText}`].filter(Boolean).join('\n')
        },

        recalculateSchedule(row, recalculateShip = true) {
            if (recalculateShip) {
                if (row.orderDate && row.leadDays !== null && row.leadDays !== undefined && row.leadDays !== '') {
                    row.estShipDate = this.addDays(row.orderDate, Number(row.leadDays))
                } else {
                    row.estShipDate = null
                }
            }

            if (row.estShipDate && row.qcLeadDays !== null && row.qcLeadDays !== undefined && row.qcLeadDays !== '') {
                row.estInboundDate = this.addDays(row.estShipDate, Number(row.qcLeadDays))
            } else {
                row.estInboundDate = null
            }
        },

        addDays(value, days) {
            const date = new Date(value)
            date.setDate(date.getDate() + days)
            return date
        },

        formatAmount(value) {
            return (Number(value) || 0).toFixed(2)
        },

        findTreeLabel(nodes, value) {
            for (const node of nodes || []) {
                if (node.value === value || node.id === value) return node.label || node.name || node.text || ''
                const childLabel = this.findTreeLabel(node.children, value)
                if (childLabel) return childLabel
            }
            return ''
        },

        getDefaultChannel() {
            const userInfo = this.$store.getters.getUserInfo || {}
            return this.forms.departmentName
                || this.findTreeLabel(this.departments, this.forms.departmentID)
                || userInfo.departmentName
                || ''
        },

        onDepartmentChange(value) {
            this.forms.departmentID = value || ''
            this.forms.departmentName = this.findTreeLabel(this.departments, value)
            const defaultChannel = this.getDefaultChannel()
            this.details.forEach(detail => {
                if (!detail.channel) detail.channel = defaultChannel
                detail.goldAvailabilityStatus = ''
            })
            this.scheduleGoldPreview()
        },

        ensureDetailUiState(detail) {
            if (!detail._formKey) {
                this.detailKeySeed += 1
                detail._formKey = `detail-${this.detailKeySeed}`
            }
            if (!detail._activeSection) detail._activeSection = 'product'
            return detail
        },

        detailFieldId(detail, field) {
            return `${detail._formKey}-${field}`
        },

        validateDetail(detail, index) {
            const prefix = `第 ${index + 1} 条明细：`
            if (!detail.detailId || !detail.productName) {
                return { field: 'detailId', message: `${prefix}请选择SKU，货品名称不能为空`, section: 'product' }
            }
            if (!detail.channel) {
                return { field: 'channel', message: `${prefix}请选择备货渠道`, section: 'product' }
            }
            if (!detail.unitName) {
                return { field: 'unitName', message: `${prefix}单位不能为空`, section: 'product' }
            }
            if (!detail.requiredQuantity || detail.requiredQuantity <= 0) {
                return { field: 'requiredQuantity', message: `${prefix}申请备货数量必须大于0`, section: 'purchase' }
            }
            if (detail.hasReport === null || detail.hasReport === undefined) {
                return { field: 'hasReport', message: `${prefix}请选择是否有报告`, section: 'purchase' }
            }

            const numericFields = [
                { field: 'estimatedPrice', section: 'purchase' },
                { field: 'monthSalesQty', section: 'inventory' },
                { field: 'deptStockQty', section: 'inventory' },
                { field: 'otherDeptStockQty', section: 'inventory' },
                { field: 'transferQty', section: 'inventory' },
                { field: 'minOrderQty', section: 'purchase' },
                { field: 'nonFinishedQty', section: 'inventory' },
                { field: 'leadDays', section: 'schedule' },
                { field: 'qcLeadDays', section: 'schedule' }
            ]
            const invalidNumber = numericFields.find(({ field }) => {
                const value = detail[field]
                return value !== null && value !== undefined && value !== '' && Number(value) < 0
            })
            if (invalidNumber) {
                return {
                    ...invalidNumber,
                    message: `${prefix}成本、销量、库存、起订量和工期不能小于0`
                }
            }
            if ((Number(detail.estimatedGoldWeight) || 0) > 0 && !detail.goldMaterialCode) {
                return { field: 'goldMaterialCode', message: `${prefix}填写预计金重后必须选择金料材质`, section: 'gold' }
            }
            if (detail.allowSupplierGoldDebt && !detail.suggestSupplierCode) {
                return {
                    field: 'suggestSupplierCode',
                    message: `${prefix}允许供应商欠料时必须选择供应商并填写有效预估金价（不低于500）`,
                    section: 'purchase'
                }
            }
            if (detail.allowSupplierGoldDebt && !(Number(detail.provisionalGoldPrice) >= 500)) {
                return {
                    field: 'provisionalGoldPrice',
                    message: `${prefix}允许供应商欠料时必须选择供应商并填写有效预估金价（不低于500）`,
                    section: 'gold'
                }
            }
            if (detail.orderDate && detail.estShipDate && new Date(detail.estShipDate) < new Date(detail.orderDate)) {
                return { field: 'estShipDate', message: `${prefix}预计出货时间不能早于下单时间`, section: 'schedule' }
            }
            if (detail.estShipDate && detail.estInboundDate && new Date(detail.estInboundDate) < new Date(detail.estShipDate)) {
                return { field: 'estInboundDate', message: `${prefix}预计入库时间不能早于预计出货时间`, section: 'schedule' }
            }
            return null
        },

        revealDetailValidation(detail, validation) {
            this.activeDetailKey = detail._formKey
            detail._activeSection = validation.section || 'product'
            this.$message.error(validation.message)
            this.$nextTick(() => {
                window.setTimeout(() => {
                    const target = document.getElementById(this.detailFieldId(detail, validation.field))
                    if (!target) return
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' })
                    const input = target.querySelector('input, textarea, [tabindex]')
                    if (input && typeof input.focus === 'function') input.focus()
                }, 350)
            })
        },

        buildSubmitDetails() {
            return this.details.map(detail => {
                const payload = { ...detail }
                delete payload._formKey
                delete payload._activeSection
                return payload
            })
        },

        deleteDetailRow(index) {
            this.$confirm('确定要删除该条采购申请明细吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const deleted = this.details[index]
                this.details.splice(index, 1)
                if (deleted && this.activeDetailKey === deleted._formKey) {
                    const nextDetail = this.details[Math.min(index, this.details.length - 1)]
                    this.activeDetailKey = nextDetail?._formKey || ''
                }
                this.scheduleGoldPreview()
                this.$message({ type: 'success', message: '已删除' })
            }).catch(() => { })
        },

        downloadTemplate() {
            const billId = this.requisitionId || ''
            if (!billId) {
                this.$message.warning('请先保存申请单后再下载模板')
                return
            }

            this.$kaung.fetch({
                url: '/PurchaseRequisitionDetail/DownloadTemplate',
                method: 'get',
                params: { billId }
            }).then(res => {
                if (res && res.code === 200) {
                    this.$notify({
                        title: '导出成功',
                        message: res.content || '采购申请明细已导出',
                        type: 'success',
                        duration: 10000
                    })
                    if (res.data) {
                        window.location.href = process.env.VUE_APP_BASEURL + res.data
                    } else {
                        this.$message.warning('后端未返回下载地址')
                    }
                } else {
                    this.$message.error(res?.content || res?.message || '下载模板失败')
                }
            }).catch(err => {
                console.error('下载采购申请明细模板失败:', err)
                this.$message.error('下载模板失败，请稍后重试')
            })
        }
    }
}
</script>

<style scoped>
.attachments-pane {
    padding: 10px 0 0 10px;
}

.attachments-alert {
    margin-bottom: 12px;
}

.attachments-file-text {
    font-size: 12px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px;
    text-align: center;
    overflow-wrap: anywhere;
}

.attachments-pane :deep(.el-upload-list--picture-card .el-upload-list__item),
.attachments-pane :deep(.el-upload--picture-card) {
    width: 100px;
    height: 100px;
}

.attachments-pane :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.attachments-pane :deep(.el-upload-list__item-actions span + span) {
    margin-left: 4px;
}

.sku-suggestion {
    display: flex;
    gap: 10px;
    justify-content: space-between;
}

.sku-suggestion span:last-child {
    color: #8492a6;
    font-size: 12px;
}

.detail-collapse {
    border-top: 0;
}

.detail-collapse :deep(.el-collapse-item) {
    margin-bottom: 7px;
    border: 1px solid var(--el-border-color-light);
    border-radius: 8px;
    overflow: hidden;
}

.detail-collapse :deep(.el-collapse-item__header) {
    min-height: 42px;
    height: auto;
    padding: 4px 10px;
    line-height: 1.2;
    border-bottom: 0;
    background: var(--el-fill-color-lighter);
}

.detail-collapse :deep(.el-collapse-item.is-active .el-collapse-item__header) {
    border-bottom: 1px solid var(--el-border-color-light);
}

.detail-collapse :deep(.el-collapse-item__wrap) {
    border-bottom: 0;
}

.detail-collapse :deep(.el-collapse-item__content) {
    padding-bottom: 0;
}

.detail-card-title {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-width: 0;
    padding-right: 8px;
}

.detail-index {
    flex: 0 0 auto;
    font-weight: 700;
    color: var(--el-text-color-primary);
}

.detail-title-image {
    flex: 0 0 auto;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid var(--el-border-color-lighter);
}

.detail-title-image :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.detail-title-product {
    display: flex;
    align-items: center;
    flex: 1 1 200px;
    min-width: 100px;
    gap: 7px;
    overflow: hidden;
}

.detail-title-product strong,
.detail-title-product span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.detail-title-product span {
    flex: 0 1 auto;
    color: var(--el-text-color-secondary);
    font-size: 12px;
}

.detail-title-metric {
    flex: 0 0 auto;
    color: var(--el-text-color-regular);
    font-size: 12px;
}

.detail-title-delete {
    flex: 0 0 auto;
    margin-left: auto;
    color: var(--el-color-danger);
    cursor: pointer;
    font-size: 12px;
    outline: none;
}

.detail-title-delete:hover,
.detail-title-delete:focus-visible {
    color: var(--el-color-danger-light-3);
}

.detail-form {
    padding: 0 12px 8px;
}

.detail-section-tabs :deep(.el-tabs__header) {
    margin: 0 0 8px;
}

.detail-section-tabs :deep(.el-tabs__item) {
    height: 34px;
    padding: 0 14px;
    font-size: 13px;
    line-height: 34px;
}

.detail-section-tabs :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
}

.detail-tab-pane {
    padding: 2px 0 0;
}

.detail-section-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 28px;
    margin-bottom: 4px;
    gap: 8px;
}

.detail-tab-hint {
    color: var(--el-text-color-secondary);
    font-size: 12px;
}

.detail-form :deep(.el-form-item) {
    margin-bottom: 8px;
}

.detail-form :deep(.el-form-item__label) {
    height: 28px;
    padding: 0 8px 0 0;
    color: var(--el-text-color-regular);
    font-size: 12px;
    line-height: 28px;
}

.detail-form :deep(.el-input__wrapper),
.detail-form :deep(.el-select__wrapper) {
    min-height: 28px;
}

.detail-form :deep(.el-input-number) {
    line-height: 26px;
}

.detail-product-image {
    display: flex;
    align-items: center;
    height: 28px;
    color: var(--el-text-color-placeholder);
    font-size: 12px;
}

.detail-product-image .el-image {
    width: 28px;
    height: 28px;
    border-radius: 4px;
    border: 1px solid var(--el-border-color-lighter);
}

.detail-product-image :deep(img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.gold-availability {
    display: flex;
    align-items: center;
    min-height: 32px;
    gap: 8px;
    color: var(--el-text-color-regular);
}

@media (max-width: 900px) {
    .detail-card-title {
        gap: 6px;
    }

    .detail-title-image,
    .detail-title-status {
        display: none;
    }

    .detail-title-delete {
        margin-left: auto;
    }
}

@media (max-width: 600px) {
    .detail-collapse :deep(.el-collapse-item__header) {
        padding: 4px 8px;
    }

    .detail-card-title {
        padding-right: 2px;
    }

    .detail-title-channel,
    .detail-title-amount,
    .detail-title-product span {
        display: none;
    }

    .detail-title-product {
        flex-basis: auto;
    }

    .detail-title-metric {
        font-size: 12px;
    }

    .detail-form {
        padding: 0 8px 6px;
    }

    .detail-section-tabs :deep(.el-tabs__item) {
        padding: 0 10px;
        font-size: 12px;
    }
}
</style>
